import { TidyHomekeepingAppComponent } from '../app.component';

export const oldPages = [
  TidyHomekeepingAppComponent,
];
